module.exports = __webpack_public_path__ + "static/prosperidad-social-1761a2afeba170b00ecec1d3f157db50.png";